<template>
  <el-dialog ref="dialog" size="large" style="min-width:1280px">
    <div style="min-height:600px" v-loading="loading">
      <template v-if="show">
        <!-- 二级层级 -->
        <div v-if="level == 20">
          <div v-for="item in content">
            <!-- 一般 -->
            <template v-if="item.show_type == CONTENT_TYPE_NORMAL && item.arr">
              <all-render
                :contentId="item.arr[0].content_id"
                :dealId="item.arr[0].deal_id"
                :dataId="item.arr[0].dataId"
                :query="item.arr[0].query"
                :iden="item.arr[0].iden"
                :showType="item.arr[0].show_type"
                @sendParams="sendParams"
                @saveCallback="saveCallback">
              </all-render>
            </template>
            <!-- 一般 -->
            <!-- Tab -->
            <template v-if="item.show_type == CONTENT_TYPE_TAB && item.arr">
              <el-tabs v-model="item.activeName" @tab-click="handleClick(item)">
                <el-tab-pane v-for="tab in item.arr" :label="tab.name" :name="tab.name">
                  <div style="min-height:100px" v-loading="loading" v-if="tab.rendered">
                    <all-render
                      :contentId="tab.content_id"
                      :dealId="tab.deal_id"
                      :dataId="tab.dataId"
                      :query="tab.query"
                      :iden="tab.iden"
                      :showType="tab.show_type"
                      @sendParams="sendParams"
                      @saveCallback="saveCallback">
                    </all-render>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </template>
            <!-- Tab -->
          </div>
        </div>
        <!-- 二级层级 -->
        <!-- 一级层级 -->
        <div v-if="level == 10">
          <all-render
            :contentId="contentId"
            :dealId="dealId"
            :dataId="dataId"
            :query="query"
            :iden="iden"
            :showType="showType"
            @sendParams="sendParams"
            @saveCallback="saveCallback">
          </all-render>
        </div>
        <!-- 一级层级 -->
      </template>
    </div>
  </el-dialog>
</template>

<script>
  import http from '../../../assets/js/http'
  import cmsConfig from '../../../config/cmsConfig'
  export default {
    name: 'renderDialog',
    props: {
      contentId: {
        type: Number,
        default() {
          return 0
        }
      },
      dataId: {
        type: Number,
        default() {
          return 0
        }
      },
      query: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
        dealId: 0,
        showType: 0,
        level: 0,
        activeName: '',
        tabs: [],
        tabsByName: {},
        loading: false,
        content: [],
        iden: '',
        show: false
      }
    },
    methods: {
      openDialog() {
        this.$refs.dialog.open()
      },
      closeDialog() {
        this.show = false
        this.$refs.dialog.close()
      },
      getTabDetail() {
        this.loading = true
        this.apiGet(`cms/contents/${this.contentId}?from=1`).then((res) => {
          this.fullLoading = false
          if (res.code == 200) {
            this.level = res.data.level
            this.showType = res.data.show_type
            this.dealId = res.data.deal_id
            this.iden = res.data.iden
            if (res.data.content) {
              _(res.data.content).forEach((item) => { // 功能集
                if (item.arr && item.arr.length) {
                  item.activeName = ''
                  _(item.arr).forEach((content, key) => {
                    content.rendered = false
                    content.dataId = this.dataId
                  })
                  item.activeName = item.arr[0].name
                  item.arr[0].rendered = true
                }
              })
            }
            this.content = res.data.content
            this.show = true
          } else {
            _g.dealError(this, res)
          }
          this.loading = false
        })
      },
      setLoading(value) {
        this.loading = value
      },
      saveCallback(isSuccess) {
        if (isSuccess) {
          setTimeout(() => {
            _g.reloadPage(this)
          }, 1500)
        }
      },
      resetData() {
        this.level = 0
        this.tabs = []
        this.showType = 0
        this.dealId = 0
        this.content = []
      },
      handleClick(item) { // 切换tab
        let activeName = item.activeName
        _(item.arr).forEach((content) => {
          if (activeName == content.name) {
            content.rendered = true
            return false
          }
        })
      },
      sendParams(queryArr) {  // 获取传给同页一级功能集的参数
        if (queryArr) {
          _(queryArr).forEach((res) => {
            _(this.content).forEach((item) => {
              _(item.arr).forEach((content) => {
                if (res.contentId == content.content_id) {
                  content.dataId = res.query.dataId
                  content.query = { query: res.query.query, is_jump: res.query.is_jump }
                }
              })
            })
          })
        }
      }
    },
    beforeCreate() {
      this.$options.components.allRender = require('./allRender.vue')
    },
    created() {
      if (this.contentId) {
        this.getTabDetail()
      }
    },
    watch: {
      'contentId' () { // contentId变化
        if (this.contentId) {
          this.resetData()
          this.getTabDetail()
        }
      }
    },
    mixins: [http, cmsConfig]
  }
</script>


// WEBPACK FOOTER //
// renderDialog.vue?02289420